module.exports = __webpack_public_path__ + "static/media/shipyard_marker_dark_blue.222582ac.svg";